import { EyeOutlined, MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Space } from 'antd'
import ButtonGroup from 'antd/es/button/button-group'
import { MenuProps } from 'antd/lib'
import { FC } from 'react'
import PreviewShipmentBlank from '../../../../../../../components/buttons/preview-shipment-blank/preview-shipment-blank'
import { useUpdateRewindQueueEntryMutation } from '../../../../../../../store/api/rewind-queue-entries-api'
import useMoveToMachineMenuItem from '../../../move-to-machine/use-move-to-machine-menu-item'
import RewindQueueEntry, { Zones } from '../../../../../../../types/api/rewind-queue-entry'

interface ActionsCellProps {
    rewindQueueEntry: RewindQueueEntry
}

const ActionsCell: FC<ActionsCellProps> = ({ rewindQueueEntry }) => {
    const [updateRewindQueueEntry] = useUpdateRewindQueueEntryMutation()
    const shipment = rewindQueueEntry.rewind_job?.shipment
    const moveToMachineMenuItem = useMoveToMachineMenuItem(
        [rewindQueueEntry],
        'Переместить на станок'
    )

    const onMoveToMainZone = () => {
        updateRewindQueueEntry({
            docId: rewindQueueEntry.documentId,
            body: {
                data: {
                    zone: Zones.Main,
                },
            },
        })
    }

    const items: MenuProps['items'] = [
        {
            key: 'main',
            label: 'Вернуть в очередь',
            onClick: onMoveToMainZone,
        },
        moveToMachineMenuItem,
    ]

    if (!shipment) return null

    return (
        <Space>
            <ButtonGroup>
                <PreviewShipmentBlank
                    shipment={shipment}
                    blankType='production'
                    blankPreviewFiles={shipment.blankPreviewFiles}
                >
                    <Button
                        title='Посмотреть бланк'
                        size='small'
                        icon={<EyeOutlined />}
                        color='magenta'
                        variant='solid'
                    />
                </PreviewShipmentBlank>
            </ButtonGroup>
            <Dropdown menu={{ items }}>
                <Button size='small' icon={<MoreOutlined />} type='primary' />
            </Dropdown>
        </Space>
    )
}

export default ActionsCell
